import * as Sentry from "@sentry/react";

/**
 * Logs an error to Sentry with additional details.
 * @param {Error | string} error - The error to log (can be an Error object or a string message).
 * @param {Record<string, string | number | boolean>} extraData - Additional context (must have string keys).
 */
export const logErrorToSentry = (error: Error | string, extraData: Record<string, string | number | boolean> = {}) => {
    const errorObject = typeof error === "string" ? new Error(error) : error;
    Sentry.captureException(errorObject, { extra: extraData });
};

/**
 * Logs informational messages to Sentry with additional details.
 * @param {string} message - The information message to log.
 * @param {Record<string, string | number | boolean>} extraData - Additional context (must have string keys).
 */
export const logInfoToSentry = (message: string, extraData: Record<string, string | number | boolean> = {}) => {

    Sentry.captureMessage(message, {
        level: "info",
        extra: extraData,
    });
};

/**
 * Sets user details in Sentry (all fields are required).
 * @param {object} user - User details (id, email, username are mandatory).
 */
export const setSentryUser = (user: { id: string; username: string; }) => {
    Sentry.setUser(user);
};

/**
 * Logs page navigation to Sentry Breadcrumbs.
 * @param {string} pageName - The name of the page the user navigated to.
 */
export const trackPageView = (pageName: string) => {
    Sentry.addBreadcrumb({
        category: "navigation",
        message: `User navigated to ${pageName}`,
        level: "info",
    });
};